import './SelectOnDrawer.scss';

import { CheckOutlined, LoadingOutlined } from '@ant-design/icons';
import { List } from 'antd';
import Search from 'antd/es/input/Search';
import { DefaultOptionType } from 'antd/es/select';
import VirtualList from 'rc-virtual-list';
import { ReactNode, UIEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { useSelectOnDrawer } from './useSelectOnDrawer';

interface SelectOnDrawerProps {
  options?: DefaultOptionType[];
  filter: any;
  selection?: any;
  notFoundContent: ReactNode;
  mode: 'multiple' | 'tags' | undefined;
  onChange?: Function;
  onSearch?: Function;
  setOpenDrawer: Function;
  dynamicHeight: boolean;
  loading?: boolean;
  handleScroll?: (e: UIEvent<HTMLElement>) => void;
}

const SelectOnDrawer = (props: SelectOnDrawerProps) => {
  const { t } = useTranslation();
  const {
    options,
    filter,
    selection,
    onChange,
    onSearch,
    mode,
    setOpenDrawer,
    notFoundContent,
    dynamicHeight,
    loading,
  } = props;
  const { heightStyle, searchValue, optionsToShow, onClick, onChangeSearch } = useSelectOnDrawer(
    options,
    filter,
    selection,
    onChange,
    onSearch,
    mode,
    setOpenDrawer,
    dynamicHeight,
  );

  return (
    <div className="SelectOnDrawer" style={heightStyle}>
      <Search
        value={searchValue}
        onChange={onChangeSearch}
        className="SelectOnDrawerSearcher"
        size="large"
      />
      {optionsToShow && optionsToShow.length != 0 ? (
        <List>
          <VirtualList data={optionsToShow} itemKey="key">
            {(item: DefaultOptionType) => {
              const selected = Array.isArray(selection)
                ? selection.includes(item.value)
                : selection == item.value;

              return (
                <List.Item
                  className={`SelectOnDrawerOption ${selected ? 'Selected' : ''}`}
                  key={String(item.value)}
                  id={`drawer-select-item-${item.value || 'undefined'}`}
                  onClick={() => onClick(item.value, item, selected)}>
                  {item.label}
                  {selected && <CheckOutlined className="SelectOnDrawerOptionSelectedIcon" />}
                </List.Item>
              );
            }}
          </VirtualList>
        </List>
      ) : (
        <div style={{ ...heightStyle, minHeight: 400 }}>
          {loading ? (
            <div className="SelectOnDrawerLoading">
              <LoadingOutlined />
            </div>
          ) : (
            <p className="SelectOnDrawerOptionEmpty">
              {searchValue != ''
                ? t('No se encontraron resultados para su búsqueda')
                : notFoundContent}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default SelectOnDrawer;
